// Gatsby requirements
import React from 'react'
import { storyblokInit } from "gatsby-source-storyblok"

// Components
import Footer from './Footer'
import Header from './Header'

// Styles
import '../../styles/Global.scss'

const Layout = ({isPageHomepage, enableDarkMode, children, url}) => {

    storyblokInit({
        accessToken: process.env.GATSBY_STORYBLOK_ACCESS_TOKEN,
    });

    return(
        <>
            <Header isPageHomepage={isPageHomepage} enableDarkMode={enableDarkMode} />
                {children}
            <Footer url={url} />

            {/* <!-- Google Tag Manager (noscript) --> */}
            <noscript
                dangerouslySetInnerHTML={{
                    __html: `
                    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PQT275H"
                        height="0" width="0" style="display:none;visibility:hidden">
                    </iframe>
                    `,
                }}
            />
            {/* <!-- End Google Tag Manager (noscript) --> */}
        </>
    )
}

export default Layout